export const SERVER_RESOURCE = '/events'
export const SERVER_RESOURCE_USER_COMMUNITY_PREFERENCE = '/user_community_preference'

export const FETCH_EVENTS = 'FETCH_EVENTS'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const ADD_EVENT = 'ADD_EVENT'
export const EDIT_EVENT = 'EDIT_EVENT'
export const FETCH_SCHEDULE_TYPES = 'FETCH_SCHEDULE_TYPES'
export const ADD_SCHEDULE_TYPE = 'ADD_SCHEDULE_TYPE'
export const UPDATE_SCHEDULE_TYPE = 'UPDATE_SCHEDULE_TYPE'
export const UPDATE_USER_COMMUNITY_PREFERENCE = 'UPDATE_USER_COMMUNITY_PREFERENCE'
export const PLEASE_SELECT_A_SCHEDULE_TYPE = 'Please select a report type'
export const WEEKLY_SUMMARY_REPORT = 'Weekly Summary Report'
export const CONTENT_REVIEW_REPORT = 'Content Review Report'
export const UPDATE_REPORTS_SEARCH_STRING = 'UPDATE_REPORTS_SEARCH_STRING'
export const SELECT_SORT_AND_FILTER = 'SELECT_SORT_AND_FILTER'

interface ScheduleTypes {
  [key: string]: string;
}

export const SupportedReports: string[] = [
  'content_review',
  'generate_report',
]

export const ReportTypes: ScheduleTypes = {
  calendar: WEEKLY_SUMMARY_REPORT,
  data: CONTENT_REVIEW_REPORT,
}

export const SERVER_PAGE_SIZE = 50

export const SORT_BY = {
  Asc: 'asc',
  Desc: 'desc',
}



// WEBPACK FOOTER //
// ./src/pages/admin-reports/constants.ts